import { useState } from "react";

import TabsWithBadge from "V2.0/common/tabsWithBadge";

import { WhatsappPhoneNumbers } from "./Whatsapp_phone_numbers";
import { WhatsappTemplates } from "./Whatsapp_templates";

import { useWhatsappTemplates } from "V2.0/HomePages/Integrations/Whatsapp/models/useWhatsappTemplates";

const WHATSAPP_TABS = {
  PHONE_NUMBERS: "Phone numbers",
  TEMPLATES: "Templates",
};

const WhatsappTabs = {
  [WHATSAPP_TABS.PHONE_NUMBERS]: (props) => <WhatsappPhoneNumbers {...props} />,
  [WHATSAPP_TABS.TEMPLATES]: (props) => <WhatsappTemplates {...props} />,
};

export function WhatsappManager(props) {
  const { existingConfiguration, projectId, fetchWhatsappConfiguration, isViewOnly } =
    props;
  const [activeTab, setActiveTab] = useState(WHATSAPP_TABS.PHONE_NUMBERS);
  // OLD: only `templates` was needed before the Refresh Status button was added to the
  // Templates tab toolbar. `fetchTemplates` is now also destructured so it can be
  // passed down as `onRefreshStatus`, matching Frontend's version.
  // const { templates } = useWhatsappTemplates(projectId);
  const { templates, fetchTemplates } = useWhatsappTemplates(projectId);

  const tabs = Object.values(WHATSAPP_TABS).map((tab) => ({
    name: tab,
    current: tab === activeTab,
    href: "#",
  }));

  return WhatsappTabs[activeTab]({
    existingConfiguration,
    projectId,
    fetchWhatsappConfiguration,
    templates,
    tabs,
    setActiveTab,
    disabled: isViewOnly,
    onRefreshStatus: () => fetchTemplates(projectId),
    projectId
  });
}
